module.exports = Em.Handlebars.compile("{{outlet}}");